import angular from 'angular';

export default class StocksConfigurationProduitsController {
	/* @ngInject */
	constructor(
		$scope,
		$state,
		$uibModal,
		notification,
		$translate,
		$filter,
		moment,
		StocksConfigurationProduitsService,
		MassiaRightsService,
		localStorageService,
		_
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModal = $uibModal;
		this.notification = notification;
		this.$translate = $translate;
		this.$filter = $filter;
		this.moment = moment;
		this.StocksConfigurationProduitsService = StocksConfigurationProduitsService;
		this.MassiaRightsService = MassiaRightsService;
		this.localStorageService = localStorageService;
		this._ = _;
		this.loading = false;
		this.idSite = null;
		this.idNiveau = 0;
		this.societes = [];
		this.idSociete = null;
		this.sites = [];
		this.idSite = null;
		this.niveaux = [];
		this.produits = [];
		this.produitsCibles = [];
		this.isConfigGenerale = true;
		this.idConfig = 0;
		this.produitCiblesOrdered = undefined;
	}

	async $onInit() {
		this.config = [
			{ id: 0, label: this.$translate.instant('STOCKS_CONFIGURATION_PRODUITS.CONFIGURATION_GENERALE') },
			{ id: 1, label: this.$translate.instant('STOCKS_CONFIGURATION_PRODUITS.CONFIGURATION_TRANSFERT_PRODUIT_CIBLE') }
		];
		await this.loadNiveauxHierarchique();

		if (this.niveauxHierarchique.length > 0) {
			this.niveaux = [{ id: 0, label: '---' }, ...this.niveauxHierarchique];
		}
		await this.loadSocietes();
		const societeId = this.localStorageService.get('STOCK_CONFIG_PROD_STOCK_SOCIETE_ID');
		if (this.societes.length > 0) {
			this.idSociete = societeId || this.societes[0].id;
			if (this.idSociete) {
				this.localStorageService.set('STOCK_CONFIG_PROD_STOCK_SOCIETE_ID', this.idSociete);
				await this.loadSites();
				if (this.sites.length > 0) {
					const stockSiteId = this.localStorageService.get('STOCK_CONFIG_PROD_STOCK_SITE_ID');
					this.idSite = stockSiteId || this.sites[0].id;
					if (this.idSite) {
						await this.loadProduits();
						await this.loadProduitsCiblesGroupeSite();
					}
				}
			}
		}

		this.$scope.$watch('$ctrl.idSociete', async (newValue, oldValue) => {
			if (newValue !== oldValue) {
				this.localStorageService.set('STOCK_CONFIG_PROD_STOCK_SOCIETE_ID', newValue);
				await this.loadSites();
				this.idSite = this.sites.length > 0 ? this.sites[0].id : null;
				this.init();
			}
		});
		this.$scope.$watch('$ctrl.idSite', async (newValue, oldValue) => {
			if (newValue !== oldValue) {
				this.localStorageService.set('STOCK_CONFIG_PROD_STOCK_SITE_ID', newValue);
				this.init();
				await this.loadProduitsCiblesGroupeSite();
			}
		});
	}
	handleChangeConfig() {
		this.isConfigGenerale = this.idConfig === 0;
	}

	init() {
		this.idNiveau = 0;
		this.idConfig = 0;
		this.produits = [];
		this.produitsCibles = [];
		this.produitCiblesOrdered = undefined;
		this.isConfigGenerale = true;
	}
	async loadSocietes() {
		this.startLoading();
		try {
			this.societes = await this.StocksConfigurationProduitsService.getSocietes();
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async loadSites() {
		this.startLoading();
		try {
			this.sites = await this.StocksConfigurationProduitsService.getSites(this.idSociete);
			this.idSite = this.sites.length > 0 ? this.sites[0].id : null;
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async loadNiveauxHierarchique() {
		try {
			this.niveauxHierarchique = await this.StocksConfigurationProduitsService.getProduitsStocksElements();
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async loadProduits() {
		this.startLoading();
		try {
			const niveau = this.idNiveau !== 0 ? this.idNiveau.niveauHierarchiqueId + ';' + this.idNiveau.elementId : 'ALL';
			this.produits = await this.StocksConfigurationProduitsService.getProduitsBySiteAndNiveau(this.idSite, niveau);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async loadProduitsCiblesGroupeSite() {
		this.startLoading();
		try {
			this.produitsCibles = await this.StocksConfigurationProduitsService.getProduitsCiblesGroupeSiteBySite(this.idSite);
			await this.getElementsSelectionnables();
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	copyList(produit) {
		return this.setSelected(angular.copy(this.produitCiblesOrdered), produit);
	}

	setSelected(liste, produit) {
		const idsProduitCible = produit.produitCibleIds;
		const idsProducteurCible = produit.produitCibleProducteurIds;
		let coupleProduitProducteur = produit.coupleProduitProducteur;
		if (!coupleProduitProducteur || coupleProduitProducteur.length != idsProduitCible.length) {
			coupleProduitProducteur = [];
			for (let indexP = 0; indexP < idsProduitCible.length; indexP++) {
				coupleProduitProducteur.push({
					produit: idsProduitCible[indexP],
					producteur: idsProducteurCible[indexP]
				});
			}
		}
		//on supprime de la liste le produit
		const index = liste.findIndex((item) => item.idProduit === produit.id && item.idProducteur === produit.producteurId);
		if (index > -1) {
			liste.splice(index, 1);
		}

		if (coupleProduitProducteur.length > 0) {
			return liste.map((item) => {
				const couple = coupleProduitProducteur.find(
					({ produit, producteur }) => produit == item.idProduit && (producteur == 0 || producteur == item.idProducteur)
				);
				return { ...item, selected: couple != undefined };
			});
		}

		produit.coupleProduitProducteur = coupleProduitProducteur;
		return liste;
	}

	debug() {
		console.log('🔥: StocksConfigurationProduitsController -> this.produits', this.produits);
	}

	getNiveaux(produit, niveau) {
		if (niveau === 0) return this.niveauxHierarchique;

		if (this.niveauxHierarchique && produit.niveau0ToString && niveau === 1) {
			const niveau0 = this.niveauxHierarchique.find((niveau0) => niveau0.id.elementId === produit.niveau0ToString.split(';')[1]);
			if (niveau0) return niveau0.items;
		}
		if (this.niveauxHierarchique && produit.niveau0ToString && produit.niveau1ToString && niveau === 2) {
			const parent = this.niveauxHierarchique.find((niveau0) => niveau0.id.elementId === produit.niveau0ToString.split(';')[1]);
			const niveau1 = parent.items.find((niveau1) => niveau1.id.elementId === produit.niveau1ToString.split(';')[1]);
			return niveau1.items;
		}
	}

	goToProduit(produit) {
		const url = this.$state.href('produits.edit', { id: produit.id });
		window.open('gestion.html' + url);
	}

	goToFormule(produit, domain, action) {
		if (!this.MassiaRightsService.userHasRight(domain, action, 'gestion')) return;
		const url = this.$state.href('formules.produit', { produitId: produit.id, producteurId: produit.producteurId });
		window.open('gestion.html' + url);
	}

	handleChange($event, produit) {
		produit.isChanged = true;
	}

	isValidate(produit) {
		return produit.niveau0ToString === null || produit.niveau1ToString === null || produit.niveau2ToString === null;
	}

	isChangedProductList() {
		return this.produits.some((produit) => produit.isChanged);
	}

	isProducteur(produit) {
		return produit.producteurId === this.idSite;
	}

	isEmptyNiveau2() {
		return this.produits.filter((produit) => produit.niveau2ToString === null).length > 0;
	}

	// boutons de validation
	async sauvegarder() {
		let isAllright = true;
		if (this.isEmptyNiveau2()) {
			isAllright = await this.openAlertEmptyRowModal();
		}
		if (isAllright) {
			this.startLoading();
			try {
				const produitsChangedToUpdate = this.produits.filter((produit) => produit.isChanged);
				await this.StocksConfigurationProduitsService.updateProduitsStock(this.idSite, produitsChangedToUpdate);
				this.notification.success(this.$translate.instant('STOCKS_CONFIGURATION_PRODUITS.SUCCESS_UPDATE'));
			} catch (ex) {
				this.notification.error(ex.data);
				return false;
			} finally {
				this.stopLoading();
			}
			await this.loadProduits();
		} else {
			this.stopLoading();
		}
	}

	onSelectProduitCible(produitSelected, produit) {
		const idsProduitCible = produit.produitCibleIds;
		let idsProducteurCible = produit.produitCibleProducteurIds;
		let coupleProduitProducteur = produit.coupleProduitProducteur;
		if (!coupleProduitProducteur || coupleProduitProducteur.length != idsProduitCible.length) {
			coupleProduitProducteur = [];
			for (let indexP = 0; indexP < idsProduitCible.length; indexP++) {
				coupleProduitProducteur.push({
					produit: idsProduitCible[indexP],
					producteur: idsProducteurCible[indexP]
				});
			}
		}

		if (idsProducteurCible == null) idsProducteurCible = [];
		if (produitSelected) {
			const index = coupleProduitProducteur.findIndex(
				({ produit, producteur }) => produit == produitSelected.idProduit && producteur == produitSelected.idProducteur
			);
			if (index > -1) {
				idsProduitCible.splice(index, 1);
				idsProducteurCible.splice(index, 1);
				coupleProduitProducteur.splice(index, 1);
			} else {
				idsProduitCible.push(produitSelected.idProduit);
				idsProducteurCible.push(produitSelected.idProducteur);
				coupleProduitProducteur.push({ produit: produitSelected.idProduit, producteur: produitSelected.idProducteur });
			}
			produit.isChanged = true;
		}
		produit.produitCibleIds = idsProduitCible;
		produit.produitCibleProducteurIds = idsProducteurCible;
		produit.coupleProduitProducteur = coupleProduitProducteur;
	}

	onSelectProduitCibleNone(produit) {
		produit.produitCibleIds = [];
		produit.produitCibleProducteurIds = [];
		produit.coupleProduitProducteur = [];
		produit.isChanged = true;
	}

	onSelectProduitCibleAll(produit) {
		produit.produitCibleIds = [];
		produit.produitCibleProducteurIds = [];
		produit.coupleProduitProducteur = [];

		this.produitCiblesOrdered.forEach((p) => {
			if (p.idProduit) {
				produit.produitCibleIds.push(p.idProduit);
				produit.produitCibleProducteurIds.push(p.idProducteur);
				produit.coupleProduitProducteur.push({
					produit: p.idProduit,
					producteur: p.idProducteur
				});
			}
		});
		produit.isChanged = true;
	}

	getLabels(liste) {
		if (liste.length > 0) {
			const selectedItems = liste.filter((x) => x.selected);
			if (selectedItems.length > 0) {
				return selectedItems.map((item) => `[${item.codeProduit}] ${item.libelleProduit}`).join('<br>');
			}
			return this.$translate.instant('STOCKS_CONFIGURATION_PRODUITS.AUCUN_PRODUIT_SELECTIONNE');
		}
		return this.$translate.instant('STOCKS_CONFIGURATION_PRODUITS.AUCUN_PRODUIT_SELECTIONNE');
	}

	async getElementsSelectionnables() {
		try {
			if (typeof this.produitCiblesOrdered == 'undefined') {
				let indexToDelete = -1;
				let allProduits = angular.copy(this.produitsCibles);
				allProduits.splice(indexToDelete, 1);

				// Distinct par produit / producteur
				const result = allProduits.reduce((prev, el) => {
					if (prev.some((o) => o.idProducteur == el.idProducteur && o.idProduit == el.idProduit)) return prev;
					return [...prev, el];
				}, []);

				this.produitCiblesOrdered = await this.prepareListeElementsLies(result);
			}
		} catch (err) {
			if (err.data) this.notification.error(err.data);
			else throw err;
		}
	}

	async prepareListeElementsLies(elementsATraiter) {
		var elementsSelectionnablesOrdonnes = this.$filter('orderBy')(elementsATraiter, 'siteProducteur');
		var tmp = null;
		var temp = [];
		for (var index = 0; index < elementsSelectionnablesOrdonnes.length; index++) {
			var currentValue = elementsSelectionnablesOrdonnes[index];
			var toReturn = [];

			//#region Gestion des groupes
			if (tmp == null) {
				//creation du premier groupe
				tmp = currentValue.idProducteur;
				toReturn.push({ libelle: '<span="font-weight:bold">' + currentValue.siteProducteur + '</span>', msGroup: true });
			} else {
				if (tmp != currentValue.idProducteur) {
					//création des autres groupes
					toReturn.push({ msGroup: false });
					tmp = currentValue.idProducteur;
					toReturn.push({ libelle: '<span="font-weight:bold">' + currentValue.siteProducteur + '</span>', msGroup: true });
				}
			}
			//#endregion
			currentValue.libelle = currentValue.codeProduit + ' - ' + currentValue.libelleProduit;
			currentValue.valeur = false;
			currentValue.idComposant = currentValue.idProduit;
			currentValue.code = currentValue.codeProduit;
			// currentValue.idProducteur = currentValue.idProducteur;
			toReturn.push(currentValue);

			if (index == elementsSelectionnablesOrdonnes.length - 1) {
				toReturn.push({ msGroup: false });
			}

			temp.push(toReturn);
		}
		var sorties = this._.flatten(temp);
		return new Promise((resolve) => resolve(sorties));
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	selectItem(data, theme) {
		if (theme === 'idSociete') {
			this.idSociete = data.id;
		}
		if (theme === 'idSite') {
			this.idSite = data.id;
		}
	}

	async openAlertEmptyRowModal() {
		const modalInstance = this.$uibModal.open({
			animation: true,
			size: 'md',
			backdrop: false,
			windowClass: 'modern-modal',
			template: `                
                <div class="modal-header modal-info mas-column mas-p-10" style="gap: 5px">
                    <div class="mas-col-fit">
                        <button type="button" class="close" aria-label="Close" ng-click="$ctrl.close()">
                            <span style="color: white" aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title"><span translate="STOCKS_CONFIGURATION_PRODUITS.ONE_ROW_NOT_COMPLETE"></span></h4>
                    </div>
                </div>
                <div class="modal-body">
                    <span translate="STOCKS_CONFIGURATION_PRODUITS.ONE_ROW_NOT_COMPLETE_WARNING"></span>							
                </div>
                <div class="modal-footer">
                    <div class="mas-col-fit">
                        <div class="mas-row mas-jc-fend">
                            <div class="mas-col-fit">
                                <button class="btn btn-primary" type="button" ng-click="$ctrl.validate()">
                                    <span translate="VALIDER"></span>
                                </button>
                                <button class="btn btn-primary" type="button" ng-click="$ctrl.close()">
                                    <span class="massia-icon-door_exit"></span>
                                    <span class="hidden-xs" translate="FERMER"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>`,
			controllerAs: '$ctrl',
			controller: [
				'$uibModalInstance',
				function ($uibModalInstance) {
					this.validate = () => {
						$uibModalInstance.close();
					};
					this.close = () => $uibModalInstance.dismiss('cancel');
				}
			]
		});
		return modalInstance.result.then(function () {
			return true;
		});
	}

	// Metjode pour aider les administrateurs à remplir les niveaux hiérarchiques
	//se declache uniquement si la touche controle est enfoncée + double click de la souris sur le libelle "Niveaux hiérarchiques"
	handleNiveauxHierarchiqueClick($event) {
		//ajoute la condition si la touche controle est enfoncée + double click de la souris pour le declanchement de la methode
		if (($event.ctrlKey || $event.metaKey) && $event.detail === 2) {
			alert('Niveaux hiérarchiques cliqués !');

			if (this.produits.length > 0) {
				this.produits = this.produits.map((produit) => {
					produit.isChanged = true;

					// Niveau 2
					const niveaux2List = this.getNiveaux(produit, 2) || [];
					if (!produit.niveau2ToString && niveaux2List.length > 0 && niveaux2List[0].id) {
						produit.niveau2ToString = niveaux2List[0].id.niveauHierarchiqueId + ';' + niveaux2List[0].id.elementId;
					}

					// Niveau 1
					const niveaux1List = this.getNiveaux(produit, 1) || [];
					if (!produit.niveau1ToString && niveaux1List.length > 0 && niveaux1List[0].id) {
						produit.niveau1ToString = niveaux1List[0].id.niveauHierarchiqueId + ';' + niveaux1List[0].id.elementId;
					}

					// Niveau 0
					const niveaux0List = this.getNiveaux(produit, 0) || [];
					if (!produit.niveau0ToString && niveaux0List.length > 0 && niveaux0List[0].id) {
						produit.niveau0ToString = niveaux0List[0].id.niveauHierarchiqueId + ';' + niveaux0List[0].id.elementId;
					}

					return produit;
				});
			}
		}
	}
}
